/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { FormAddressProject } from "../types/AdressTypes";

type Response = {
  payload: {
    dataproject:FormAddressProject[]
  };
};

export function useProjectAddress(project_id:number) {

    const params={
        project_id: project_id
    }

    const api = useApi();
    const [data, setData] = useState<FormAddressProject>();
    const [isLoading, setLoading] = useState(true);
    const hasFetched = useRef(false);

    const fetchData = () => {
        setLoading(true);

        api
        .get("project/byid",{params})
        .then((res: SuccessFetch<Response>) => {
            const data = res.data.payload.dataproject[0] ?? null;
            setData(data);
        })
        .catch(() => {})
        .finally(() => setLoading(false));
    };

    const refetch = () => fetchData();

    useEffect(() => {
        if (hasFetched.current) return; // tidak fetch ulang
        hasFetched.current = true;
        fetchData();

        return () => {
        };
        // eslint-disable-next-line
    }, []);

    return {
        data,
        isLoading,
        refetch,
    };
}
